import { Card } from "antd";
import styled from "styled-components";

export const CardStyled = styled(Card)`
    .ant-card-body {
        padding: 0;
    }
`;
